import { Flex } from 'components/primitives/flex';
import { useAtomValue, useAtom } from 'jotai';
import styled from 'styled-components';
import { getMaxWidthQuery } from 'helpers/breakpoints';
import { useEffect, useMemo } from 'react';
import { duplicateCheckboxAtomArrayAtom } from 'components/search/v2/Filter/filterAtomUtils';
import { durationHoursAtom, durationHoursTempAtom } from '../filterStore';
import AtomCheckButton, { renderAtomCheckButton } from '../fields/AtomCheckButton';
import { breakpoints } from '../../styleConstants';

export default function DurationFilterContent() {
  const durations = useAtomValue(durationHoursAtom);

  return <DurationWrapper gap="20px">{durations.map(renderAtomCheckButton)}</DurationWrapper>;
}

const DurationWrapper = styled(Flex)`
  max-width: 272px;
  flex-wrap: wrap;

  ${getMaxWidthQuery(breakpoints.QUICK_FILTER_BOTTOM_SHEET_MAX)} {
    max-width: ${breakpoints.QUICK_FILTER_BOTTOM_SHEET_MAX}px;
  }

  & > div {
    width: 46%;
  }
`;

export function DurationFilterContentWithTempAtom() {
  const [tempDurations, setTempDurations] = useAtom(durationHoursTempAtom);
  const newDurationsVal = useAtomValue(useMemo(() => duplicateCheckboxAtomArrayAtom(durationHoursAtom), []));

  useEffect(() => {
    setTempDurations(newDurationsVal);
  }, []);

  const tempDurationsList = tempDurations.map((item) => ({
    ...item,
    label: `${item.label.split(' ')[0]} hours`,
  }));
  return (
    <DurationWrapperSmall gap="16px">
      {tempDurationsList.map(({ value, label, checkedAtom }) => (
        <AtomCheckButton key={value} checkedAtom={checkedAtom} label={label} />
      ))}
    </DurationWrapperSmall>
  );
}

const DurationWrapperSmall = styled(Flex)`
  width: 100%;
  flex-wrap: wrap;

  & > div {
    width: calc(50% - 8px);
  }
`;
